import { Box, Link, Typography } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { BrandIcon, BrandIconType } from '../../../BrandIcon';

type ContentRibbonProps = StructuredContentDocument<{
  title: string;
  icon?: BrandIconType;
  description?: string;
  href?: string;
  linkText?: string;
  headingLevel: 2 | 3;
}>;

export const ContentRibbon = ({ props }: ContentRibbonProps) => {
  const { title, icon, description, href, linkText, headingLevel = 3 } = props;

  return (
    <Box sx={{ bgcolor: 'yellows.lightest', padding: 2, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {icon ? <BrandIcon name={icon} size={30} /> : null}
        <Typography component={`h${headingLevel}`} variant="h3">
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginLeft: {
            xs: 0,
            md: icon ? '46px' : 0,
          },
        }}
      >
        {description ? (
          <Typography
            sx={{
              marginTop: 0.5,
            }}
          >
            {description}
          </Typography>
        ) : null}
        {href ? (
          <Typography
            variant="textSmallBold"
            sx={{
              marginTop: 0.5,
            }}
          >
            » MORE:{' '}
            <Link href={href}>
              <Typography variant="text">{linkText}</Typography>
            </Link>
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};
